import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-table',
  templateUrl: './status-table.component.html',
  styleUrls: ['./status-table.component.less']
})
export class StatusTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
